/**
 * Utility function to format timestamps to always display in UTC
 * Never converts to local timezone to maintain consistency across users
 *
 * @param timestamp The timestamp to format (ISO string or Date object)
 * @returns A human-readable UTC date string with UTC indicator
 */
export function formatTimestamp(timestamp: string | Date): string {
  try {
    const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return timestamp.toString() || 'Invalid date';
    }

    // Format as UTC with explicit UTC indicator
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'UTC',
      hour12: false,
    };

    const formatted = date.toLocaleString('en-US', options);

    return `${formatted} UTC`;
  } catch (e) {
    console.error('Error formatting timestamp:', e);

    return timestamp.toString() || 'Unknown date';
  }
}
